export const AheadTime = new Array(72).fill('').map((v, i) => ({ value: i + 1 + '', precis: i + 1 + '', label_EN: i + 1 + '' }))
